







































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { TbReport, TbShopAccount,TbTbHandover } from "@/http";
import { calendarPanel, NumberKeyboard } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
  },
})
export default class staffbb extends Vue {
  public $refs: {};

  curZL = 1;
  fmoney = fmoney;
  /**查询项- */
  searchValue1 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    cashierId: "",
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    sortField: 1,
    sortType: 2,
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    jobNumberOrName: "",
    startDate: dayjs(new Date()).format("YYYY-MM"),
    endDate: dayjs(new Date()).format("YYYY-MM"),
    sort: null,
    skip: 0,
    count: 10,
  };
  //交接班
  searchValue3 = {
    key: "",
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  payType = null;

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  total = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_ze = "0.00";
  hj_xsnum = 0;
  hj_sxnum = 0;
  hj_the = "0.00";
  hj_sxze = "0.00";
  hj_zkze = "0.00";

  hj_xjnovip = "0.00";
  hj_xj = "0.00";
  hj_cash = "0.00";
  hj_wechat = "0.00";
  hj_alipay = "0.00";
  hj_vipcard = "0.00";
  hj3_ze = "0.00";
  hj3_sxze = "0.00";
  hj3_czze = "0.00";

  total_Cash = "0.00";
  total_AddMemberNum = 0;
  total_RechargePrice = "0.00";
  total_SalesAmount = "0.00";
  total_ReturnAmount = "0.00";
  total_RechargePriceCash = "0.00";
  total_RechargePriceNum = 0;
  total_ReturnAmountNum = 0;
  total_ReturnAmountCash = "0.00";
  total_ReturnAmountCard = "0.00";
  total_SalesAmountNum = 0;
  total_SalesAmountCash = "0.00";
  total_SalesAmountCard = "0.00";
  total_Imprest = "0.00";
  total_BalanceCash = "0.00";
  //
  total_RechargePriceOfflineWeChat = "0.00";
  total_RechargePriceOfflineAlipay = "0.00";
  total_RechargePriceAlipay = "0.00";
  total_RechargePriceWeChat = "0.00";
  total_ReturnAmountOfflineWeChat = "0.00";
  total_ReturnAmountOfflineAlipay = "0.00";
  total_ReturnAmountAlipay = "0.00";
  total_ReturnAmountWeChat = "0.00";
  total_SalesAmountOfflineAlipay = "0.00";
  total_SalesAmountOfflineWeChat = "0.00";
  total_SalesAmountWeChat = "0.00";
  total_SalesAmountAlipay = "0.00";

  cashierlist = [];
  curcashierid = "";
  iscz = false;
  calshow = false;
  selkjdate = new Date();
  curseldate = dayjs(new Date()).format("YYYY-MM");
  minDate = new Date(new Date().getFullYear() - 1, 0, 1);
  maxDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  @Watch("searchValue2.jobNumberOrName")
  nameChange2(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue3.key")
  nameChange3(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  created() {}

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    this.getcashierlist();
  }

  chooseZL(tag) {
    this.curZL = tag;
    this.clearSearch();
    this.iscz = true;
    this.getList();
  }
  clearSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          cashierId: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 1,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          jobNumberOrName: "",
          startDate: dayjs(new Date()).format("YYYY-MM"),
          endDate: dayjs(new Date()).format("YYYY-MM"),
          sort: null,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          key: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.selkjdate = new Date();
    this.curseldate = dayjs(new Date()).format("YYYY-MM");
  }

  openselDate() {
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : "searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : "searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    switch (this.curZL) {
      // 销售订单
      case 1:
        let resjy = await TbReport.GetSellingGoodsList(Object.assign({}, this[arg]));
        this.list = this[arg].skip == 0 ? resjy.item2 : this.list.concat(resjy.item2);
        this.total = resjy.item1.total;
        this.hj_ze = resjy.item1.total;
        this.hj_xsnum = resjy.item1.returnNum;
        this.hj_sxnum = resjy.item1.actualNum;
        this.hj_zkze = fmoney(resjy.item1.actualTotal, 2);
        this.iscz = false;
        break;
      // 员工月度提成
      case 2:
        let reszf = await TbReport.GetAccountReportList(Object.assign({}, this[arg]));
        this.list2 = this[arg].skip == 0 ? reszf.items : this.list2.concat(reszf.items);
        this.total = reszf.totalCount;
        this.iscz = false;
        break;
      // 交接班
      case 3:
        let resjjb = await TbTbHandover.GetTbHandoverList(Object.assign({}, this[arg]));
        this.list3 = this[arg].skip == 0 ? resjjb.items.map(v=>{
          return {
            ...v,
            timefirst:v.workClass.split(" - ")[0],
            timeend:v.workClass.split(" - ")[1],
          }
        }) : this.list3.concat(resjjb.items.map(v=>{
          return {
            ...v,
            timefirst:v.workClass.split(" - ")[0],
            timeend:v.workClass.split(" - ")[1],
          }
        }));
        this.total = resjjb.totalCount;
        let resjjbtotal = await TbTbHandover.GetHandoverTotal(Object.assign({}, this[arg]));
        this.total_Cash = fmoney(resjjbtotal.total_Cash, 2);
        this.total_AddMemberNum = resjjbtotal.total_AddMemberNum;
        this.total_RechargePrice = fmoney(resjjbtotal.total_RechargePrice, 2);
        this.total_SalesAmount = fmoney(resjjbtotal.total_SalesAmount, 2);
        this.total_ReturnAmount = fmoney(resjjbtotal.total_ReturnAmount, 2);
        this.total_RechargePriceCash = fmoney(resjjbtotal.total_RechargePriceCash, 2);
        this.total_RechargePriceNum = resjjbtotal.total_RechargePriceNum;
        this.total_ReturnAmountNum = resjjbtotal.total_ReturnAmountNum;
        this.total_ReturnAmountCash = fmoney(resjjbtotal.total_ReturnAmountCash, 2);
        this.total_ReturnAmountCard = fmoney(resjjbtotal.total_ReturnAmountCard, 2);
        this.total_SalesAmountNum = resjjbtotal.total_SalesAmountNum;
        this.total_SalesAmountCash = fmoney(resjjbtotal.total_SalesAmountCash, 2);
        this.total_SalesAmountCard = fmoney(resjjbtotal.total_SalesAmountCard, 2);
        this.total_Imprest = fmoney(resjjbtotal.total_Imprest, 2);
        this.total_BalanceCash = fmoney(resjjbtotal.total_BalanceCash, 2);
        //
        this.total_RechargePriceOfflineWeChat = fmoney(resjjbtotal.total_RechargePriceOfflineWeChat, 2);
        this.total_RechargePriceOfflineAlipay = fmoney(resjjbtotal.total_RechargePriceOfflineAlipay, 2);
        this.total_RechargePriceAlipay = fmoney(resjjbtotal.total_RechargePriceAlipay, 2);
        this.total_RechargePriceWeChat = fmoney(resjjbtotal.total_RechargePriceWeChat, 2);
        this.total_ReturnAmountOfflineWeChat = fmoney(resjjbtotal.total_ReturnAmountOfflineWeChat, 2);
        this.total_ReturnAmountOfflineAlipay = fmoney(resjjbtotal.total_ReturnAmountOfflineAlipay, 2);
        this.total_ReturnAmountAlipay = fmoney(resjjbtotal.total_ReturnAmountAlipay, 2);
        this.total_ReturnAmountWeChat = fmoney(resjjbtotal.total_ReturnAmountWeChat, 2);
        this.total_SalesAmountOfflineAlipay = fmoney(resjjbtotal.total_SalesAmountOfflineAlipay, 2);
        this.total_SalesAmountOfflineWeChat = fmoney(resjjbtotal.total_SalesAmountOfflineWeChat, 2);
        this.total_SalesAmountWeChat = fmoney(resjjbtotal.total_SalesAmountWeChat, 2);
        this.total_SalesAmountAlipay = fmoney(resjjbtotal.total_SalesAmountAlipay, 2);
        this.iscz = false;
        break;
      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
  }
  /**获取商品列表 */
  async getList() {
    this.onRefresh();
  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          cashierId: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sortField: 1,
          sortType: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          jobNumberOrName: "",
          startDate: dayjs(new Date()).format("YYYY-MM"),
          endDate: dayjs(new Date()).format("YYYY-MM"),
          sort: null,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          key: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.iscz = true;
    this.selkjdate = new Date();
    this.curseldate = dayjs(new Date()).format("YYYY-MM");
    this.getList();
  }
  async sortFun(val) {
    if (this.curZL == 1) {
      switch (val) {
        case 0:
          this.searchValue1.sortField = 0;
          break;
        case 1:
          this.searchValue1.sortField = 1;
          break;
        case 2:
          this.searchValue1.sortField = 2;
          break;
        default:
          break;
      }
      this.searchValue1.sortType = this.searchValue1.sortType == 2 ? 1 : 2;
    }
    if (this.curZL == 2) {
      switch (val) {
        case 1:
          this.searchValue2.sort == 1
            ? (this.searchValue2.sort = 2)
            : (this.searchValue2.sort = 1);
          break;
        case 2:
          this.searchValue2.sort == 3
            ? (this.searchValue2.sort = 4)
            : (this.searchValue2.sort = 3);
          break;
        default:
          break;
      }
    }
    this.iscz = false;
    await this.getList();
  }
  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1.start = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue1.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 2:
        this.searchValue2.startDate = dayjs(new Date()).format("YYYY-MM");
        this.searchValue2.endDate = dayjs(new Date()).format("YYYY-MM");
        break;
      case 3:
        this.searchValue3.start = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue3.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      default:
        break;
    }
    this.iscz = false;
    await this.getList();
  }
  async getcashierlist() {
    try {
      let res = await TbShopAccount.GetTbShopAccountDropList({
        shopid: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
      });
      this.cashierlist = res;
    } catch (error) {}
  }
  selcashier(id) {
    this.curcashierid = id;
    this.searchValue1.cashierId = id;
    this.iscz = false;
    this.getList();
  }
  opencal() {
    this.calshow = true;
  }
  formatter(type, value) {
    if (type === "year") {
      return `${value}年`;
    }
    if (type === "month") {
      return `${value}月`;
    }
    return `${value}日`;
  }
  onClose() {
    this.calshow = false;
  }
  Confirm(value) {
    console.log(value);
    this.selkjdate = value;
    this.curseldate = dayjs(value).format("YYYY-MM");
    this.searchValue2.startDate = dayjs(value).format("YYYY-MM");
    this.searchValue2.endDate = dayjs(value).format("YYYY-MM");
    this.getList();
    this.calshow = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/staffbb.vue